import { Bot, Database, MessageSquare, TrendingUp, Users, Zap } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { Badge } from "@/components/ui/badge";

const icons = [Bot, Database, MessageSquare, TrendingUp, Users, Zap];

const BenefitsSection = () => {
  const { t, tObject } = useLanguage();
  
  const benefitItems = tObject<Array<{ title: string; description: string }>>('benefits.items');
  
  return (
    <section id="vorteile" className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t('benefits.tag')}</Badge>
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            {t('benefits.title')}
          </h2>
          <p className="text-lg text-chathero-orange font-semibold max-w-2xl mx-auto">
            {t('benefits.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefitItems.map((benefit, index) => {
            const Icon = icons[index % icons.length];
            return (
              <div
                key={index}
                className="group bg-background rounded-2xl p-8 border border-border hover:border-chathero-mint hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-xl bg-chathero-mint/10 flex items-center justify-center mb-6 group-hover:bg-chathero-mint/20 transition-colors">
                  <Icon className="w-7 h-7 text-chathero-mint" />
                </div>
                <h3 className="text-xl font-semibold text-primary mb-3">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;